module.exports = __webpack_public_path__ + "media/images/consumer/signup/payment/credit-card/discover@2x-6fee9b7933fe2776d30c3b58cfccf419.png";